import {Component, Input, OnInit} from '@angular/core';
import {ProceduresService} from '../../services/procedures.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
@Component({
  selector: 'ngx-document-bridge',
  templateUrl: './document-bridge.component.html',
  styleUrls: ['./document-bridge.component.scss'],
})
export class DocumentBridgeComponent implements OnInit {
  sourceData: LocalDataSource;
  @Input() stationId: string;
  loading = false;
  politics = [];
  dataFormatted = [];
  itemSelected = {
    id: 0,
    code: '',
    type: '',
    name: '',
    documents: [],
    data: { columnB: '' },
  };
  settings: any = {
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.svg" class="mx-1 hover-cursor-pointer" width="35px">'
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.svg" class="mr-1 hover-cursor-pointer" width="35px">'
        },
        {
          name: 'folder',
          title: '<img src="assets/images/icons/folder.svg" class="hover-cursor-pointer" width="35px">'
        },
        {
          name: 'detail',
          title: '<img src="assets/images/icons/next.svg" class="hover-cursor-pointer mx-1" width="35px">'
        },
      ]
    },
    pager: { perPage: 15 },
    columns: {
      name: { title: 'Nombre', filter: true },
      code: { title: 'Código', filter: true },
      updated_at: { title: 'Fecha', filter: true }
    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private proceduresService: ProceduresService,
  ) { }

  ngOnInit() {
    // this.getDocuments();
  }

  async getMockDocumentBridge() {
    this.loading = true;
    const [error, response] = await this.proceduresService.getDataDocumentBridge(this.stationId);
    this.loading = false;
    if (error) return console.error(error);
    const mocks = response.data.mocks.map(item => {
      return {
        id: item.id,
        type: 'mock',
        custom_mock: item.custom_mock,
        documents: item.documents,
        name: item.data.columnA,
        code: item.custom_mock ? item.custom_mock.data.columnB : item.data.columnB,
        review:item.custom_mock ? item.custom_mock.review : 0,
        updated_at: item.custom_mock && item.custom_mock.review ? moment(item.custom_mock.updated_at).format('DD-MM-YYYY hh:mm a') : ''
      }
    })

    const customMocksStation = response.data.custom_mocks_station.map(item => {
      return {
        id: item.id,
        type: 'custom_mock',
        custom_mock: null,
        documents: item.documents,
        name: item.data.columnA,
        code: item.data.columnB,
        review:item.review,
        updated_at: moment(item.updated_at).format('DD-MM-YYYY hh:mm a')
      }
    })

    this.sourceData = mocks.concat(customMocksStation) as any
  }

  selectedItem(event, idModal: string) {
    this.itemSelected = event.data
    // @ts-ignore
    $(idModal).modal('show');
  }

  async editItem() {
    this.loading = true;
    const [error] = await this.proceduresService.editOrStoreItemMock({
      mock_id: this.itemSelected.id, data: { columnB: this.itemSelected.code }, station_id: this.stationId });
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    // @ts-ignore
    $('#edit-document-bridge').modal('hide');
    this.getMockDocumentBridge();
    this.alert('Éxito', 'success');
  }

  async store () {
    this.loading = true;
    const [error] = await this.proceduresService.storeWithoutMockParent({ data: { columnA: this.itemSelected.name, columnB: this.itemSelected.code }, station_id: this.stationId });
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    // @ts-ignore
    $('#create-document-bridge').modal('hide');
    this.getMockDocumentBridge();
    this.alert('Éxito', 'success');
  }

  onCustom ($event) {
    console.error($event)
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
